import { render, staticRenderFns } from "./ChevronLeftDoubleBack.vue?vue&type=template&id=63a533f1"
import script from "./ChevronLeftDoubleBack.vue?vue&type=script&lang=js"
export * from "./ChevronLeftDoubleBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports